import { ServiceProvider } from ".";
import EventTypes from "../shared/EventTypes";
import { clickMouseOnCanvas, doubleClickedOnCanvas, mouseDragged, mouseMoved, mouseWheel, pressMouseOnCanvas, releaseMouseOnCanvas } from "../shared/mouseFunctions";
import { windowResized } from "../shared/utils";
import { keyPressed } from '../view/keyFunctions';

const s = (p) => {
    let provider;
    let sideBarOpen = false;

    p.setup = () => {
        provider = new ServiceProvider(p);
        p.createCanvas(provider.p.windowWidth, provider.p.windowHeight)
            .mouseReleased(releaseMouseOnCanvas(provider))
            .mouseClicked(clickMouseOnCanvas(provider))
            .mousePressed(pressMouseOnCanvas(provider))
            .doubleClicked(doubleClickedOnCanvas(provider));
        provider.init();
        windowResized(provider);
    };

    p.draw = () => {
        p.background(provider.backgroundColor);

        if (provider.settings.showImage
            && provider.image
            && provider.image.loaded
        ) {
            p.push();
            p.translate(provider.view.posX, provider.view.posY);
            provider.image.display();
            p.pop();
        }

        provider.grid.display();

        p.push();
        p.translate(provider.view.posX, provider.view.posY);

        provider.tools.currentTool.display();

        provider.elements.display();

        p.pop();

        provider.speciesInfo.display();
        provider.sideBar.display();
        provider.grid.displayLegend();
        provider.spinner.display();
    };

    p.windowResized = () => {
        windowResized(provider);
    }

    p.mouseDragged = (event) => {
        mouseDragged(event, provider);
    }

    p.mouseMoved = () => {
        mouseMoved(provider);
    }

    p.mouseWheel = (event) => {
        mouseWheel(event, provider);
    }

    p.keyPressed = () => {
        keyPressed(provider, p.keyCode);
    }

    /**
     * These functions are handled by events directly on the canvas.
     * They are defined to prevent the triggering of touch events which
     * happens if they are defined, but not these functions.
     */
    p.mousePressed = () => { }
    p.mouseReleased = () => { }

    p.touchStarted = (event) => {
        if (provider.sideBar.hovered()) {
            return;
        } else if (provider.zoomMenu.hovered()) {
            return;
        } else if (provider.mobile && provider.sideBar.isOpen) {
            sideBarOpen = true;
            provider.emit(EventTypes.CLOSE_SIDEBAR);
            return false;
        }
        return provider?.tools.currentTool.startTouch(event);
    }

    p.touchMoved = (event) => {
        if (sideBarOpen) {
            return false;
        } else if (provider.sideBar.hovered()) {
            return;
        }
        return provider?.tools.currentTool.moveTouch(event);
    }

    p.touchEnded = (event) => {
        if (sideBarOpen) {
            sideBarOpen = false;
            return false;
        } else if (provider.sideBar.hovered()) {
            return;
        }
        return provider?.tools.currentTool.endTouch(event);
    }
};
let planSketch = new p5(s, 'p5canvas');

export { s, planSketch };
